import React from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateLocale } from "@icarius-localization/strings";
import { getLocalizedString } from "@icarius-localization/strings";

const DateInput = (props) => {
    const {
        fieldConfig,
        label,
        value,
        handleChange,
        required,
        error,
    } = props;

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
            <KeyboardDatePicker
                required={required}
                fullWidth
                clearable
                cancelLabel={getLocalizedString("disagree")}
                okLabel={getLocalizedString("accept")}
                clearLabel={getLocalizedString("clear")}
                invalidDateMessage=''
                minDateMessage=''
                maxDateMessage=''
                format="dd/MM/yyyy"
                margin="none"
                label={label}
                value={value}
                error={error}
                onChange={(e) => handleChange(e, fieldConfig.name)}
            />
        </MuiPickersUtilsProvider>
    )
}

export default DateInput;